
class WLPageSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    // Swiperの設定値を取得
    const slidesPerView = parseInt(this.dataset.slidesPerView) || 3.5;
    const spaceBetween = parseInt(this.dataset.spaceBetween) || 16;
    const navigation = this.dataset.navigation === 'true';
    const pagination = this.dataset.pagination === 'true';
    const autoplay = this.dataset.autoplay === 'true';
    
    // スライダーのコンテナを取得
    const wrapper = this;
    // Swiperを初期化
    const adjustSlideHeights = () => {
      const slides = document.querySelectorAll('.swiper-slide');
      const maxHeight = Array.from(slides).reduce((max, slide) => {
        return Math.max(max, slide.offsetHeight);
      }, 0);
  
      slides.forEach(slide => {
        slide.style.height = `${maxHeight}px`;
      });
    }
    new Swiper(wrapper, {
      slidesPerView: 3, // スライド数
      spaceBetween: "2%", // スライド間の余白
      freeMode: true, // 前後のスライドで止まらずにスライド
      grabCursor: true, // カーソルを置いたときに指のカーソルを表示
      autoHeight: true, // 初期設定
      loop: true, // ループ
      on: {
        init: function () {
          adjustSlideHeights();
        },
        slideChangeTransitionEnd: function () {
          adjustSlideHeights();
        }
      },
      // ページネーション
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
    });
  }
  
}

// カスタムエレメントを登録
document.addEventListener('DOMContentLoaded', () => {
  customElements.define('wl-page-slider', WLPageSlider);
});

export default WLPageSlider;